export const TOKEN_LOGIN = "TOKEN_LOGIN";
export const RETRIEVE_USER = "RETRIEVE_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const GET_INSTANCE_DETAILS = "GET_INSTANCE_DETAILS";
export const CHECK_DATASTORE_CREDENTIALS_CHANGED = "CHECK_DATASTORE_CREDENTIALS_CHANGED";
export const FETCH_MARKETPLACE_DATA = "FETCH_MARKETPLACE_DATA";
export const FETCH_ACCEPTED_TCS = "FETCH_ACCEPTED_TCS";
